import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getLoyaltyCompanyContactInfo,
  getLoyaltyCompanyLogo,
} from '../../../utils/LoyaltyCompanies';
import AlternateEmail from '../../../assets/icons/AlternateEmail';
import PhoneOutlined from '../../../assets/icons/PhoneOutlined';
import BrowserIcon from '../../../assets/icons/BrowserIcon';

const CompanyInfo = ({ loyaltyCompany }) => {
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    setContactInfo(getLoyaltyCompanyContactInfo(loyaltyCompany));
  }, [loyaltyCompany]);

  return (
    <div className="offer_wrapper">
      <div className="logo_wrapper">
        <div className="logo_img_container">
          <img
            alt="Company Logo"
            src={getLoyaltyCompanyLogo(loyaltyCompany)}
            className="landscape-horizonal"
          />
        </div>
      </div>
      <p className="info_paragraph">
        <PhoneOutlined className="info_icons" />
        {contactInfo?.phone}
      </p>
      <p className="info_paragraph">
        <AlternateEmail className="info_icons" />
        {contactInfo?.email}
      </p>
      <p className="info_paragraph">
        <BrowserIcon className="info_icons" />
        <Link
          className="info_link"
          to={{ pathname: `https://${contactInfo?.webSite}` }}
          target="_blank"
        >
          {contactInfo?.webSite}
        </Link>
      </p>
    </div>
  );
};

export default CompanyInfo;
